import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class TimeZoneService {

  constructor(
    private sharedService: SharedService,
  ) { }

  //https://gisgeography.com/world-time-zone-map/

  toUserTimeZone(timestring: any) {
    const timezone = this.sharedService.timeZone;
    if (typeof(timestring) === 'string') {
      return moment.utc(timestring).tz(timezone);
    } else if (typeof timestring === 'number') {
      return moment.unix(timestring).tz(timezone);
    }
  };

  toUtcTimeZonefromUser(timestring: any,format="YYYY-MM-DD HH:mm:ss") {
    const timezone = this.sharedService.timeZone;
    if (typeof timestring === 'string') {
      return moment.tz(timestring,format, timezone).utc()
    } else if (typeof timestring === 'number') {
      return moment.unix(timestring).utc();
    }
  }

  getcurrentuserTime() {
    const timezone = this.sharedService.timeZone;
    // console.log("->",this.sharedService.timeZone)
    // console.log("->",moment().tz(timezone))
    return moment.tz(timezone);
  }

  setcurrentuserTime(timestring: any) {
    const timezone = this.sharedService.timeZone;
    return moment.tz(timestring, timezone);
  }

  getuserTimegivenepoch(timestring: any) {
    const timezone = this.sharedService.timeZone;
    return moment.unix(timestring).tz(timezone)
  }

  getUtcTime() {
    return moment().utc()
  }

  usertimezone = 'Asia/Kolkata';
  servertimezone = 'Asia/Tokyo';

  toservertimezonefromuser(timestring: any) {
    if (typeof timestring === 'string') {
      return moment.tz(timestring, this.usertimezone).tz(this.servertimezone);
    } else if (typeof timestring === 'number') {
      return moment.unix(timestring).tz(this.servertimezone);
    }
  }
}